import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import Container from 'common/Container';
import {
  Hero,
  ExpedientesSection,
  Metrics,
  Products,
  ValueAdd,
  InvestmentSummary,
  AreYouReady,
} from './components';

const LandingMediaKitAtache = ({ themeMode = 'light' }) => {
  return (
    <Box>
      <Container>
        <Hero themeMode={themeMode} />
      </Container>
      <Container>
        <ExpedientesSection />
      </Container>
      <Container>
        <Metrics />
      </Container>
      <Container>
        <Products />
      </Container>
      <Container>
        <ValueAdd />
      </Container>
      <Container>
        <InvestmentSummary />
      </Container>
      <Container>
        <AreYouReady />
      </Container>
    </Box>
  );
};

LandingMediaKitAtache.propTypes = {
  themeMode: PropTypes.string,
};

export default LandingMediaKitAtache;
